// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__mrmKN {
  display: flex;
  flex-direction: column; }
  .styles_container__mrmKN > div {
    width: 100%;
    height: 2.5rem;
    max-height: 2.5rem;
    overflow: auto;
    display: flex;
    align-items: center;
    flex-direction: row; }
    .styles_container__mrmKN > div > div {
      width: 100%;
      border: none; }
    .styles_container__mrmKN > div input {
      max-height: 90%;
      height: -webkit-fill-available;
      padding: unset;
      padding-left: 0.5rem; }
    .styles_container__mrmKN > div fieldset {
      border: none; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/MultiTextInput/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAa;EACb,sBAAsB,EAAA;EAF1B;IAIQ,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB,EAAA;IAV3B;MAYY,WAAW;MACX,YAAY,EAAA;IAbxB;MAgBY,eAAe;MACf,8BAA8B;MAC9B,cAAc;MACd,oBAAoB,EAAA;IAnBhC;MAsBY,YAAY,EAAA","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    & > div {\n        width: 100%;\n        height: 2.5rem;\n        max-height: 2.5rem;\n        overflow: auto;\n        display: flex;\n        align-items: center;\n        flex-direction: row;\n        & > div {\n            width: 100%;\n            border: none;\n        }\n        & input {\n            max-height: 90%;\n            height: -webkit-fill-available;\n            padding: unset;\n            padding-left: 0.5rem;\n        }\n        & fieldset {\n            border: none;\n        }\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__mrmKN`
};
export default ___CSS_LOADER_EXPORT___;
